import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  CoursePauseRequestPagination,
  COURSE_PAUSE_REQUEST_STATUSES,
  currentPageSelector,
  useFilteredCoursePauseRequests,
} from 'features/courseResume';
import ApprovedTableHeader from '../ApprovedTableHeader';
import ApprovedTableRow from '../ApprovedTableRow';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './ApprovedRequestsTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function ApprovedRequestsTable() {
  const { requestType } = useParams();
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useFilteredCoursePauseRequests({
      requestType,
      coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.accepted,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load approved requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const approvedRequests = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <ApprovedTableHeader />
          <TableBody>
            {approvedRequests.map((request) => (
              <ApprovedTableRow
                request={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="approved-request-pagination" />
        <div
          id="approved-request-pagination"
          className={styles.pagination}
        >
          <CoursePauseRequestPagination
            pageCount={data.meta?.total}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No requests found!"
        message="No approved pause requests exist at the moment!"
      />
    );
  }
}

export default ApprovedRequestsTable;
